import { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { CancelButton, SubmitButton } from "../../components/btns";
import { errorAlert, successAlert } from "../../components/toastr";
import { createRegistration } from "../../resources/api/events";

export const emptyRegistration = { full_name: "", email: "", phone: "", organisation: "", job_title: "" };

const RegistrationForm = ({ eventId, show, setShow, onSave }) => {
    const [details, setDetails] = useState(emptyRegistration);
    const [validated, setValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (show) setDetails(emptyRegistration);
    }, [show]);

    const change = e => {
        const { name, value } = e.currentTarget;
        setDetails(details => ({ ...details, [name]: value }));
    };
    const submit = e => {
        e.preventDefault();
        if (!e.currentTarget.checkValidity()) {
            setValidated(true);
            return errorAlert("Provide the attendee's required details.", "Form Errors");
        }
        setSubmitting(true);
        createRegistration(eventId, { ...details, registration_method: "desk" })
            .then(({ registration, message }) => {
                successAlert(message);
                onSave(registration);
                setShow(false);
                setValidated(false);
            })
            .catch(errorAlert)
            .finally(() => setSubmitting(false));
    };

    return (
        <Modal show={show} onHide={() => setShow(false)} centered animation={false} backdrop="static">
            <Modal.Header closeButton className="bg-secondary text-light"><Modal.Title>Register Attendee</Modal.Title></Modal.Header>
            <Form noValidate validated={validated} onSubmit={submit}>
                <Modal.Body>
                    <Row className="g-2">
                        <Col xs={12}><Form.Label className="form-field-title">Full Name</Form.Label><Form.Control name="full_name" value={details.full_name} onChange={change} required /></Col>
                        <Col sm={6}><Form.Label className="form-field-title">Email</Form.Label><Form.Control type="email" name="email" value={details.email} onChange={change} /></Col>
                        <Col sm={6}><Form.Label className="form-field-title">Telephone</Form.Label><Form.Control type="tel" name="phone" value={details.phone} onChange={change} /></Col>
                        <Col sm={6}><Form.Label className="form-field-title">Organisation</Form.Label><Form.Control name="organisation" value={details.organisation} onChange={change} /></Col>
                        <Col sm={6}><Form.Label className="form-field-title">Job Title</Form.Label><Form.Control name="job_title" value={details.job_title} onChange={change} /></Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="py-1">
                    <SubmitButton type="submit" isSubmitting={submitting}>Register</SubmitButton>
                    <CancelButton type="button" isSubmitting={submitting} onClick={() => setShow(false)}>Cancel</CancelButton>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default RegistrationForm;
